import {
  apiContainer,
  queryBuilder,
  massageSingleRecordBeforeUpsert
} from './apiContainer'

import { ArtificialDetailPropertyNames } from '../../common/globalNotary'
import uuid from 'react-uuid'

const SLICE_API_ROOT = '/contracts'

const contractApi = apiContainer.injectEndpoints({
  endpoints: build => ({
    listContracts: build.query({
      query: args => queryBuilder(SLICE_API_ROOT, args)
    }),
    getOneFatContract: build.query({
      async queryFn (_arg, _queryApi, _extraOptions, fetchWithBQ) {
        const callArray = [fetchWithBQ(`${SLICE_API_ROOT}/${_arg.id}`)]
        const primaryRes = await Promise.all(callArray)
        const primaryData = primaryRes[0].data.data

        const listOfOwnerIds = primaryData.owners.map(o => o.id)
        const listOfContactIds = primaryData.contacts.map(o => o.id)

        callArray.splice(0, callArray.length)

        callArray.push(fetchWithBQ(`/entities?contract_id=${_arg.id}`))
        callArray.push(fetchWithBQ(`/assets?contract_id=${_arg.id}`))

        let numberOfPartyCalls = 0
        if (listOfOwnerIds.length) {
          callArray.push(
            fetchWithBQ(queryBuilder('/parties', { ids: listOfOwnerIds }))
          )

          numberOfPartyCalls++
        }
        if (listOfContactIds.length) {
          callArray.push(
            fetchWithBQ(queryBuilder('/parties', { ids: listOfContactIds }))
          )
          numberOfPartyCalls++
        }

        const auxiliaryRes = await Promise.all(callArray)

        const entities = auxiliaryRes[0].data.data
        const assets = auxiliaryRes[1].data.data

        const fullOwners = listOfOwnerIds.length
          ? auxiliaryRes[2].data.data
              .filter(f => {
                return primaryData.owners.some(o => {
                  return f.id === o.id
                })
              })
              .map(f => {
                const match = primaryData.owners.find(c => {
                  return c.id === f.id
                })
                f.role_id = match.role_id
                f.name = `${f.first_name} ${f.last_name}`.trim()
                f.type = f.base_type

                return f
              })
          : []

        const fullContacts = listOfContactIds.length
          ? auxiliaryRes[1 + numberOfPartyCalls].data.data
              .filter(f => {
                return primaryData.contacts.some(o => {
                  return f.id === o.id
                })
              })
              .map(f => {
                const match = primaryData.contacts.find(c => {
                  return c.id === f.id
                })
                f.role_id = match.role_id
                f.name = `${f.first_name} ${f.last_name}`.trim()
                f.type = f.base_type
                return f
              })
          : []

        primaryData.fullContacts = fullContacts
        primaryData.fullOwners = fullOwners

        primaryData[ArtificialDetailPropertyNames.DETACHED_DEPENDENCY1] =
          entities
        primaryData[
          ArtificialDetailPropertyNames.DETACHED_DEPENDENCY1_INITIAL_VALUES
        ] = entities

        primaryData[ArtificialDetailPropertyNames.DETACHED_DEPENDENCY2] = assets
        primaryData[
          ArtificialDetailPropertyNames.DETACHED_DEPENDENCY2_INITIAL_VALUES
        ] = assets

        // tmp fix for saving auxiliary updates
        return { data: { data: { ...primaryData, _objectId: uuid() } } }
      }
    }),
    listContractRoles: build.query({
      query: () => `${SLICE_API_ROOT}/~/roles`,
      keepUnusedDataFor: 86400
    }),
    bulkUpdateContracts: build.mutation({
      query: args => {
        return {
          url: SLICE_API_ROOT,
          method: 'PATCH',
          body: { data: args }
        }
      }
    }),
    upsertContract: build.mutation({
      query: args => {
        const { id } = args
        const actualArgs = massageSingleRecordBeforeUpsert(args)

        actualArgs.contacts = actualArgs.fullContacts.map(o => {
          return { id: o.id, role_id: o.role_id }
        })
        actualArgs.owners = actualArgs.fullOwners.map(o => {
          return { id: o.id, role_id: o.role_id }
        })
        delete actualArgs.fullContacts
        delete actualArgs.fullOwners

        if (id) {
          // update

          return {
            url: `${SLICE_API_ROOT}/${id}`,
            method: 'PUT',
            body: actualArgs
          }
        } //insert
        else {
          return {
            url: SLICE_API_ROOT,
            method: 'POST',
            body: actualArgs
          }
        }
      }
    }),
    deleteContract: build.mutation({
      query: args => {
        return {
          url: `${SLICE_API_ROOT}/${args.id}`,
          method: 'DELETE'
        }
      }
    })
  }),
  overrideExisting: true
})

export const {
  useGetOneFatContractQuery,
  useLazyListContractsQuery,
  useLazyListContractRolesQuery,
  useUpsertContractMutation,
  useDeleteContractMutation,
  useBulkUpdateContractsMutation,
} = contractApi
